const RAW_TITLE_PREFIX = '__RAW_TITLE__:'

export function formatPageTitle(title?: string | null): string {
  if (!title) return 'Gala Season'
  if (title.startsWith(RAW_TITLE_PREFIX)) return title.slice(RAW_TITLE_PREFIX.length)

  return `${title} — Gala Season`
}

export function rawPageTitle(title: string): string {
  return `${RAW_TITLE_PREFIX}${title}`
}
